import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_BASE_URL;

console.log('API URL:', apiUrl);

axios.defaults.baseURL = apiUrl;
axios.defaults.headers.common['Authorization'] = localStorage.getItem('token') || '';
axios.defaults.timeout = 10000;

export default axios;
